import Enum from '/@/modules/core/app/helpers/Enum';
import { Icon } from '/@/modules/core/app/enums/Icon';
import Lang from '/@/modules/core/app/services/Lang';

export class FileType extends Enum {
  key!: string;
  value!: string;
  icon?: string;
  specifier!: string;

  static CSV: FileType = {
    key: 'csv',
    get value(): string {
      return Lang.t('document.comma-value-file');
    },
    get icon(): string {
      return FileType.getClassName(FileType.CSV.key);
    },
    specifier: '.csv'
  };

  static DOC: FileType = {
    key: 'doc',
    get value(): string {
      return Lang.t('document.microsoft-word-file');
    },
    get icon(): string {
      return FileType.getClassName(FileType.DOC.key);
    },
    specifier: '.doc'
  };

  static DOCX: FileType = {
    key: 'docx',
    get value(): string {
      return Lang.t('document.microsoft-word-file');
    },
    get icon(): string {
      return FileType.getClassName(FileType.DOC.key);
    },
    specifier: '.docx'
  };

  static PDF: FileType = {
    key: 'pdf',
    get value(): string {
      return Lang.t('document.pdf-file');
    },
    get icon(): string {
      return FileType.getClassName(FileType.PDF.key);
    },
    specifier: '.pdf'
  };

  static PNG: FileType = {
    key: 'png',
    get value(): string {
      return Lang.t('document.png-image');
    },
    get icon(): string {
      return FileType.getClassName(FileType.PNG.key);
    },
    specifier: '.png'
  };

  static JPEG: FileType = {
    key: 'jpeg',
    get value(): string {
      return Lang.t('document.jpeg-image');
    },
    get icon(): string {
      return FileType.getClassName(FileType.JPEG.key);
    },
    specifier: '.jpeg'
  };

  static JPG: FileType = {
    key: 'jpg',
    get value(): string {
      return Lang.t('document.jpg-image');
    },
    get icon(): string {
      return FileType.getClassName(FileType.JPEG.key);
    },
    specifier: '.jpg'
  };

  static XLS: FileType = {
    key: 'xls',
    get value(): string {
      return Lang.t('document.microsoft-excel-sheet');
    },
    get icon(): string {
      return FileType.getClassName(FileType.XLS.key);
    },
    specifier: '.xls'
  };

  static XLSX: FileType = {
    key: 'xlsx',
    get value(): string {
      return Lang.t('document.microsoft-excel-sheet');
    },
    get icon(): string {
      return FileType.getClassName(FileType.XLS.key);
    },
    specifier: '.xlsx'
  };

  static GIF: FileType = {
    key: 'gif',
    get value(): string {
      return Lang.t('document.gif');
    },
    get icon(): string {
      return FileType.getClassName(FileType.GIF.key);
    },
    specifier: '.gif'
  };

  static JSON: FileType = {
    key: 'json',
    get value(): string {
      return Lang.t('document.json');
    },
    specifier: '.json'
  };

  static getStandardDocumentAcceptTypes(): string[] {
    return [
      FileType.PDF.key,
      FileType.JPEG.key,
      FileType.JPG.key,
      FileType.PNG.key,
      FileType.DOC.key,
      FileType.DOCX.key,
      FileType.XLSX.key
    ];
  }

  static getStandardDocumentAcceptTypesExceptExcel(): string[] {
    return [FileType.PDF.key, FileType.JPEG.key, FileType.JPG.key, FileType.PNG.key];
  }

  static getStandardImageAcceptTypes(): string[] {
    return [FileType.PNG.key, FileType.JPEG.key, FileType.JPG.key];
  }

  static getInAppAnnouncementAcceptTypes(): string[] {
    return [...this.getStandardImageAcceptTypes(), FileType.GIF.key];
  }

  static hasIcon(icon: string): boolean {
    return [FileType.PDF.key, FileType.DOC.key, FileType.DOCX.key, FileType.XLS.key].includes(icon);
  }

  static hasImageIcon(icon: string): boolean {
    return [...this.getStandardImageAcceptTypes(), FileType.GIF.key].includes(icon);
  }

  private static getClassName(icon: string): string {
    if (this.hasIcon(icon)) {
      return `cls cls-file-${icon}`;
    }

    if (this.hasImageIcon(icon)) {
      return `cls cls-${Icon.PICTURE_POLAROID_LANDSCAPE}`;
    }

    return 'cls cls-documents';
  }

  static supportsThumbnailPreview(fileType: string): boolean {
    switch (fileType) {
      case FileType.PNG.key:
      case FileType.JPEG.key:
      case FileType.JPG.key:
      case FileType.GIF.key:
      case FileType.PDF.key:
        return true;
      default:
        return false;
    }
  }

  static supportsMobilePhone(fileType: string): boolean {
    switch (fileType) {
      case FileType.PNG.key:
      case FileType.JPEG.key:
      case FileType.JPG.key:
      case FileType.GIF.key:
        return true;
      default:
        return false;
    }
  }
}
